import { LcaGeneratedReportOutSchema } from 'src/Lca/types';

import { ReportConfig, ReportVersionRecord } from './types';

export const mapGeneratedReport = (
  report: LcaGeneratedReportOutSchema
): ReportVersionRecord => ({
  id: report.id,
  productId: report.product_id,
  reportId: report.report_id,
  seriesId: report.series_id,
  version: report.version,
  reportName: report.report_name,
  generatedAt: report.generated_at,
  generatedById: report.generated_by_id,
  generatedByName: report.generated_by_name,
  generatedByUserId: String(report.generated_by_id),
  selectedAreaId: report.selected_area_id,
  formats: report.artifacts.map((artifact) => artifact.format),
  warningsCount: report.warnings_count,
  hash: report.hash,
  configSnapshot: report.config_snapshot as ReportConfig,
  artifacts: report.artifacts.map((artifact) => ({
    id: artifact.id,
    name: artifact.name,
    size: artifact.size,
    contentType: artifact.content_type,
    url: artifact.url,
    uploadedAt: artifact.uploaded_at,
    format: artifact.format,
  })),
});

export const getLatestSeriesId = (
  history: ReportVersionRecord[]
): string | null => history[0]?.seriesId || null;

export const getLatestSeriesVersion = (
  history: ReportVersionRecord[],
  seriesId: string
): number => {
  const matching = history.filter((entry) => entry.seriesId === seriesId);
  if (!matching.length) return 0;
  return Math.max(...matching.map((entry) => entry.version));
};
